/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const AuthResponseR = t.interface({
  authToken: t.string
});

// optional attributes
const AuthResponseO = t.partial({});

export const AuthResponse = t.intersection(
  [AuthResponseR, AuthResponseO],
  "AuthResponse"
);

export type AuthResponse = t.TypeOf<typeof AuthResponse>;
